<template>
  <OrderPageSection>
    <div class="order-delivery-tile">
      <div v-if="isReset" class="order-delivery-tile-section reset-tips">
        已重置物流，待客人重新选择
      </div>
      <template v-else>
        <div class="order-delivery-tile-header c:row-between-center">
          <div class="order-delivery-tile-title">{{ title }}</div>
          <div
            v-if="canReset"
            class="order-delivery-tile-reset"
            @click="throttledOnResetDeliveryClick"
          >
            重置物流
          </div>
        </div>
        <div v-if="isPickup" class="order-delivery-tile-section pickup-info">
          <div class="order-delivery-info c:row-between-center">
            <div class="order-delivery-info-name">
              {{ order.pickupStoreVo.name }}
            </div>
            <div class="order-delivery-info-phone"></div>
          </div>
          <div class="order-delivery-address">
            {{ pickupAddress }}
          </div>
        </div>
        <template v-else-if="isExpress">
          <div class="order-delivery-tile-section delivery-info">
            <div class="order-delivery-info c:row-between-center">
              <div class="order-delivery-info-name">
                {{ order.addressVo.userName }}
              </div>
              <div class="order-delivery-info-phone">
                {{ order.addressVo.telNumber }}
              </div>
            </div>
            <div class="order-delivery-address">
              {{ customerAddress }}
            </div>
          </div>
          <div
            v-if="isStatusSent"
            class="order-delivery-tile-section logistics-info"
          >
            <div class="order-delivery-info c:row-between-center">
              <div class="order-delivery-info-name">
                {{ order.logisticsCompany }}
              </div>
              <div
                class="order-delivery-info-link"
                @click="throttledOnTrackLogisticsLinkClick"
                v-if="systemLogistics"
              >
                追踪物流详情
              </div>
            </div>
            <div class="order-delivery-number c:row-start-center">
              <span>{{ order.logisticsNo }}</span>
              <img
                src="@/assets/icons/copy.svg"
                v-clipboard:copy="order.logisticsNo"
                v-clipboard:success="onCopy"
                alt=""
              />
            </div>
            <!-- <div
              class="order-delivery-code c:row-start-center"
              v-if="
                ['SFTC'].includes(this.order.logisticsCompanyCode) &&
                order.pickupCode &&
                runInWxWork
              "
            >
              <span class="code-label">取件码</span>
              <span class="code">{{ order.pickupCode }}</span>
              <img
                class="order-delivery-pick-up-code"
                src="@/assets/icons/copy.svg"
                v-clipboard:copy="order.pickupCode"
                v-clipboard:success="onCopyPickupCode"
                alt=""
              />
            </div> -->
          </div>
        </template>
      </template>
    </div>
  </OrderPageSection>
</template>

<script>
  import { mapMutations, mapState, mapGetters } from 'vuex'
  import OrderPageSection from '../widgets/OrderPageSection.vue'
  import { throttle } from '@/utils'

  export default {
    components: {
      OrderPageSection
    },
    props: {
      order: Object,
      isCreator: Boolean,
      isStatusSent: Boolean,
      refundStatus: Object
    },
    computed: {
      ...mapGetters(['runInWxWork']),
      ...mapState(['brandInfo']),
      systemLogistics() {
        // const list = this.brandInfo.manualLogisticsVendors || []
        // const list = JSON.parse(this.brandInfo.manualLogisticsVendors) || []
        // const systemLogistics = list.filter(item => item.type === 'System')
        // const systemLogisticCodes = systemLogistics.map(item => item.code)
        // return systemLogisticCodes.includes(this.order.logisticsCompanyCode)
        return ['SF', 'SFTC'].includes(this.order.logisticsCompanyCode)
      },
      isReset() {
        return this.order.status === 20
      },
      isPickup() {
        return this.order.deliveryMethod === 1 && this.order.pickupStoreVo
      },
      isExpress() {
        return this.order.deliveryMethod === 0 && this.order.addressVo
      },
      title() {
        return this.order.deliveryMethod ? '提货门店' : '收货信息'
      },
      canReset() {
        return (
          this.brandInfo.resetDelivery?.enabled === true &&
          this.isCreator &&
          !this.refundStatus.isRefundingOrDone &&
          ((this.isPickup && this.order.status === 40) ||
            (this.isExpress && !this.isStatusSent))
        )
      },
      pickupAddress() {
        if (this.isPickup) {
          const { province, city, district, address } = this.order.pickupStoreVo
          return `${province || ''}${city || ''}${district || ''}${
            address || ''
          }`
        }
        return ''
      },
      customerAddress() {
        const { provinceName, cityName, detailInfo } = this.order.addressVo
        return `${provinceName}${cityName}${detailInfo}`
      }
    },
    created() {
      this.throttledOnResetDeliveryClick = throttle(
        () => this.$emit('resetdelivery'),
        500
      )
      this.throttledOnTrackLogisticsLinkClick = throttle(
        this.onTrackLogisticsLinkClick,
        500
      )
    },
    methods: {
      ...mapMutations(['setLogisticsOrderDetail']),
      onTrackLogisticsLinkClick() {
        this.setLogisticsOrderDetail(this.order)
        this.$router.push({
          name: 'Logistics',
          query: {
            orderId: this.order.id,
            orderNo: this.order.orderNo
          }
        })
      },
      onCopy() {
        this.$toast('物流单号复制成功')
      },
      onCopyPickupCode() {
        this.$toast('取件码复制成功')
      }
    }
  }
</script>

<style lang="less" scoped>
  .order-delivery-tile {
    padding: 20/20rem 0;

    &-title {
      line-height: 17/20rem;
      font-weight: 500;
      font-size: 12/20rem;
      letter-spacing: 0;
      color: #000;
    }
    &-reset {
      height: 24/20rem;
      padding: 0 16/20rem;
      border: 1/20rem solid #000000;

      line-height: 22/20rem;
      font-weight: 400;
      font-size: 12/20rem;
      letter-spacing: 0;
    }
    &-section {
      box-sizing: border-box;
      padding: 12/20rem 15/20rem;
      border: 1/20rem solid #e9e9e9;

      &.delivery-info,
      &.pickup-info {
        margin-top: 12/20rem;
      }
      &.logistics-info {
        margin-top: 20/20rem;
      }
      &.reset-tips {
        padding: 24/20rem 24/20rem;

        line-height: 12/20rem;
        text-align: center;
        font-size: 12/20rem;
        font-weight: 400;
        letter-spacing: 0;
        color: #999;
      }
    }
    .order-delivery-info {
      height: 13/20rem;
      line-height: 13/20rem;
      font-size: 13/20rem;
      font-weight: 500;
      letter-spacing: 0;
      color: #000;

      &-link {
        text-decoration: underline;
      }
    }

    .order-delivery-address,
    .order-delivery-number {
      margin-top: 6/20rem;
      line-height: 17/20rem;
      font-size: 12/20rem;
      font-weight: 400;
      letter-spacing: 0;
      color: #999;
    }

    .order-delivery-pick-up-code {
      width: 12/20rem;
      height: 12/20rem;
      margin-left: 5/20rem;
    }

    .order-delivery-number {
      img {
        width: 12/20rem;
        height: 12/20rem;
        margin-left: 5/20rem;
      }
    }

    .order-delivery-code {
      font-family: PingFang SC;
      font-weight: 500;
      .code-label {
        font-size: 13px;
      }
      .code {
        font-size: 16px;
        margin-left: 6/20rem;
      }
    }
  }
</style>
